import { Box, Image, Text } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Close } from '../../Icons/Close';
import Cover from '../../assets/images/bicester/services.png';
import CoverMb from '../../assets/images/bicester/services_mb.png';
import { CommonProps } from '../../interfaces/components';
import useWindowDimensions from '../../utils/hooks/useWindowDimensions';
import Service from '../../components/bicester/Service';

const BicesterServices = ({ active, setActive }: CommonProps) => {
  const { width } = useWindowDimensions();
  const { t } = useTranslation();

  return (
    <>
      <Box
        position="fixed"
        w="100%"
        h="100%"
        top="0"
        left="0"
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        backgroundColor="rgba(0,0,0,0.2)"
        transition="all 1s"
        zIndex={4}
        onClick={() => setActive()}
      />
      <Box
        zIndex={8}
        opacity={active ? 1 : 0}
        visibility={active ? 'visible' : 'hidden'}
        transition="all 0.5s"
        position="fixed"
        top={0}
        right={0}
        left={0}
        bottom={0}
        margin="auto"
        backgroundColor="rgba(255, 255, 255, 1);"
        width={['100vw', '100vw', '760px', '1000px']}
        height={['100%', '100%', '580px', '680px']}
        overflowY={['auto', 'auto', 'hidden']}
      >
        <Close
          boxSize={[6, 6, 7]}
          position="absolute"
          top={['30px', '30px', '30px']}
          right={['30px', '30px', '30px']}
          cursor="pointer"
          onClick={() => setActive()}
          zIndex={30}
        />
        <Box
          display="flex"
          flexDirection={['column', 'column', 'row']}
          overflowX={['auto', 'auto', 'hidden']}
          pb={['5', '5', '0']}
        >
          <Image
            src={width < 770 ? CoverMb : Cover}
            w={['100%', '100%', '400px', '480px']}
            h={['500px', '500px', '580px', '680px']}
            objectFit="cover"
            alt="cs"
          />
          <Box
            display="flex"
            flexDirection="column"
            mt={['10', '10', '0']}
            justifyContent="center"
            alignItems="center"
            w="100%"
          >
            <Text
              textAlign="center"
              fontWeight="400"
              fontFamily="SangBleuBPLight"
              fontSize={['16px', '16px', '18px', '20px', '20px']}
              maxW="80%"
              mx="auto"
              mb={['5', '5', '8']}
            >
              {t('bv_services_title')}
            </Text>

            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              h={['auto', 'auto', '440px', '560px']}
              overflowY={['unset', 'unset', 'auto']}
              pt="5"
              pb="10"
              gap="8"
            >
              <Box
                display="flex"
                flexFlow="row"
                flexWrap="wrap"
                justifyContent="center"
                alignItems="start"
                rowGap="10"
                columnGap="4"
              >
                <Service title={t('bv_services_one_title')} description={t('bv_services_one_description')} />
                <Service title={t('bv_services_two_title')} description={t('bv_services_two_description')} />
                <Service title={t('bv_services_three_title')} description={t('bv_services_three_description')} />
                <Service title={t('bv_services_four_title')} description={t('bv_services_four_description')} />
                <Service title={t('bv_services_five_title')} description={t('bv_services_five_description')} />
                <Service title={t('bv_services_six_title')} description={t('bv_services_six_description')} />
                <Service title={t('bv_services_seven_title')} description={t('bv_services_seven_description')} />
              </Box>

              <Text
                as="i"
                textAlign="center"
                fontWeight="400"
                fontFamily="JosefinSans"
                fontSize={['12px', '12px', '15px', '15px', '15px']}
                lineHeight={['16px', '16px', '18px', '18px', '18px']}
                className="gold"
                maxW="80%"
              >
                {t('bv_services_contact')}
              </Text>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default BicesterServices;
